'use client';
import { motion } from 'framer-motion';
import { useVideoPlayer } from '../../hooks/useVideoPlayer';

export interface VideoInlineProps {
  videoSrc: string;
  videoCaption?: string;
  thumbnail: any;
}

export const VideoInline: React.FC<VideoInlineProps> = ({ videoSrc, videoCaption, thumbnail }) => {
  const videoRef = useVideoPlayer(videoSrc, false);

  const videoReveal = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { ease: [0, 1, 1, 1], duration: 0.8 },
    },
  };

  return (
    <motion.figure className="flex flex-col gap-4" variants={videoReveal} initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.5 }}>
      <video
        ref={videoRef}
        controls
        playsInline
        className="aspect-video w-full object-cover"
        poster={thumbnail || 'https://xumo-cms.directus.app/assets/f0040323-5396-42bb-89ab-6c114f52041c'}
      />
      {videoCaption && <figcaption className="type-caption-press mt-2" dangerouslySetInnerHTML={{ __html: videoCaption }} />}
    </motion.figure>
  );
};
